import HistoryIcon from '@material-ui/icons/Loyalty'
import HistoryList from './HistoryList'
import HistoryEdit from './HistoryEdit'

export default {
    list: HistoryList,
    edit: HistoryEdit,
    icon: HistoryIcon,
}
